/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, Input } from '@angular/core';
import { BaseComponent } from '../index';
import { UserService } from '../../services';

/**
 * Avatar interface.
 */
export interface Avatar {
    color: string
    initials: string,
    fullName: string
}

@Component({
    selector: 'app-collaboration',
    templateUrl: './collaboration.component.html',
    styleUrls: ['./collaboration.component.scss']
})

export class CollaborationComponent extends BaseComponent {
    /**
     * Set if the users list is coming from a service or @Input().
     */
    @Input() public useServiceForData = false;

    /**
     * Optional incoming data.
     * @param users
     */
    @Input() set setAvatarsByUserList(users: any[]) {
        if (!this.useServiceForData && users.length) {
            this.avatars = this.formatUsers(users);
        }
    }

    /**
     * Stored avatars for the view.
     */
    public avatars: Avatar[] = [];

    constructor(
        private userService: UserService
    ) {
        super();

        if (this.useServiceForData) {
            // TODO - Get users from service or socket data (waiting for backend 30/08/24)
            // this.avatars = this.formatUsers(users);
        }

        // TODO test code to remove later
        // const userList = [
        //     { firstName: 'Dev', lastName: 'list' },
        //     { firstName: 'Matthew', lastName: 'Cooper' },
        //     { firstName: 'Mark', lastName: 'Brooks' },
        //     { firstName: 'Peter', lastName: 'Statham' },
        //     { firstName: 'Colin', lastName: 'Jones' },
        //     { firstName: 'Scott', lastName: 'Dowling' },
        //     { firstName: 'Martyn', lastName: 'Shanks' },
        //     { firstName: 'Jeff', lastName: 'Gosden' },
        //     { firstName: 'Naren', lastName: 'Iyer' },
        //     { firstName: 'Andrew', lastName: 'Zak' },
        //     { firstName: 'Adam', lastName: 'Tang' },
        //     { firstName: 'Emma', lastName: 'Rayfield' },
        // ];
    }

    /**
     * Format users.
     * @param userList
     * @private
     */
    private formatUsers(userList: any[]): Avatar[] {
        const avatars: Avatar[] = [];
        for (const user of userList) {
            if (user.firstName !== '' && user.lastName !== '') {
                avatars.push(this.userService.createUserAvatarFromNames(user.firstName, user.lastName));
            }
        }

        return avatars;
    }
}
